import { makeObservable, observable } from "mobx";
import { ImCampaignItem, ImCampaignItemStatus } from "@whatslly/types/tuvis-messaging/TuvisMessagingCampaign";

export class IMCampaignItem implements ImCampaignItem {
  _id: string;
  campaignId: string;
  orgId: string;
  phone: string;
  firstName: string;
  lastName?: string;
  parameters: Record<string, string>;
  status: ImCampaignItemStatus;
  error?: string;
  errorCode?: string;
  messageId?: string;
  contactId?: string;
  processedAt?: string;
  createdAt: string;

  constructor(data: ImCampaignItem) {
    this._id = data._id;
    this.campaignId = data.campaignId;
    this.orgId = data.orgId;
    this.phone = data.phone;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.parameters = data.parameters;
    this.status = data.status;
    this.error = data.error;
    this.errorCode = data.errorCode;
    this.messageId = data.messageId;
    this.contactId = data.contactId;
    this.processedAt = data.processedAt;
    this.createdAt = data.createdAt;

    makeObservable(this, {
      status: observable,
      error: observable,
      errorCode: observable,
      messageId: observable,
      processedAt: observable,
    });
  }
}
